/* Custom JavaScript can be included here.
Hook into variant changes on product pages with:
document.addEventListener('variant:changed', (event) => {
let variant = event.detail.variant; // Access variant details});
To react to a product being added to the cart, use:
document.addEventListener('product:added', (event) => {
let variant = event.detail.variant; // Variant added
let quantity = event.detail.quantity; // Quantity added});
To refresh the mini-cart without adding a product, trigger:
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));*/
(function(){
var modalTriggers = document.querySelectorAll('a[data-modal]');
var modals = document.querySelectorAll('.modal');Array.prototype.forEach.call(modalTriggers, function(trigger) {
trigger.addEventListener('click', function(e) { e.preventDefault();document.querySelector('#' + trigger.getAttribute('data-modal')).classList.add('modal--visible');});});
Array.prototype.forEach.call(modals, function(modal) {modal.addEventListener('click', function(e) {if (e.target.classList.contains('modal--visible')) {modal.classList.remove('modal--visible');}});});
var accordions = document.querySelectorAll(".accordion");
var openAccordion = (accordion) => {
var content = accordion.querySelector(".accordion__content");
accordion.classList.add("accordion__active");
content.style.maxHeight = `${content.scrollHeight + 50}px`;};
var closeAccordion = (accordion) => {
var content = accordion.querySelector(".accordion__content");
accordion.classList.remove("accordion__active");
content.style.maxHeight = null;};
accordions.forEach((accordion) => {
var intro = accordion.querySelector(".accordion__intro");
var content = accordion.querySelector(".accordion__content");
intro.onclick = () => {
if (content.style.maxHeight) {
closeAccordion(accordion);} else {
accordions.forEach((accordion) => closeAccordion(accordion));
openAccordion(accordion);}};});
var concierge = document.querySelector('.Concierge');
var conciergeBtn = concierge.querySelector('.Concierge__bell');
var conciergeList = concierge.querySelector('.Concierge__list');
var triggrIntercom = concierge.querySelector('#open-intercom');
conciergeBtn.addEventListener('click', () => {
conciergeList.classList.add('open');})
conciergeList.addEventListener('click', () => {
conciergeList.classList.remove('open');});
triggrIntercom.addEventListener('click', e => {
e.preventDefault();
Intercom('show');})})();
var debounce = (func, delay) => {
var timer;
return function () {
var context = this;
var args = arguments;
clearTimeout(timer);
timer = setTimeout(() => func.apply(context, args), delay);};};


(function(){
  function addSwatches() {
    const productItemSwatches = document.querySelectorAll('.ProductItem--hasSwatches');
    for (const productItems of productItemSwatches) {
      
      const swatchOptions = productItems.querySelector('.swatches ul');
      swatchOptions.innerHTML = "";
      const productWrapper = productItems.querySelector('.ProductItem--Outer')
      const productItem = productItems.querySelectorAll('.ProductItem__Wrapper');
      for (const [idx, item] of productItem.entries()) {
        const swatchBg = item?.dataset.swatchBg;
  
        if (swatchBg) {
          const swatchTitle = item?.dataset.swatchTitle;
          const swatch = document.createElement('li');
          const swatchInner = document.createElement('a');
          const swatchesContainer = productItems.querySelector('.swatches');
          const floatingSwatch = productItems.querySelector('.floating-swatch');
          const rect = floatingSwatch.offsetTop;
  
          swatchInner.style.backgroundImage = `url(${swatchBg})`;
          swatchInner.href = "#";
          swatchInner.title = swatchTitle;
  
          swatch.appendChild(swatchInner);
          swatchOptions.appendChild(swatch);
          swatchOptions.children[0].classList.add('selected');
  
          swatchesContainer.style.top = `${floatingSwatch.offsetTop + 20}px`;
  
  
        swatch.addEventListener('click', e => {
          e.preventDefault();
          swatchOptions.querySelectorAll('li').forEach(s => s.classList.remove('selected'));
          productWrapper.style.transform = `translateX(${-100 * idx}%)`;
          e.currentTarget.classList.add('selected');
        })
  
        }
      }
    }
  }
  addSwatches();
  window.addEventListener('resize', debounce(addSwatches, 100));
})();



(function(){var htmlVideos = document.querySelectorAll('.html-video');for (var item of htmlVideos) {
var video = item.querySelector('video');
var controls = item.querySelector('.controls');
var playToggle = item.querySelector('.controls .playpause');
var volToggle = item.querySelector('.volume');
var muteBtn = item.querySelector('.mute');
var unmuteBtn = item.querySelector('.unmute');
volToggle.addEventListener('click', (e) => {
e.preventDefault();
if (video.muted) {
video.muted = false;
muteBtn.style.display = 'none';
unmuteBtn.style.display = 'block';
} else {
video.muted = true;
muteBtn.style.display = 'block';
unmuteBtn.style.display = 'none';}});
unmuteBtn.addEventListener('click',()=>{
video.muted = false;
muteBtn.style.display = 'block';
unmuteBtn.style.display = 'none';});
playToggle.addEventListener('click',()=>{
if (video.paused){video.play();item.classList.add('playing');item.classList.remove('paused');} else {video.pause();item.classList.remove('playing');item.classList.add('paused');}});}})();